import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'font-awesome/css/font-awesome.min.css'
import routes from "./routes"
import Print from "./print"
import {defaultRoutes, nurseRoutes, doctorRoutes, warehouseAdminRoutes,superAdminRouter} from "./routes"

Vue.use(VueRouter);
Vue.use(ElementUI, {locale});
Vue.use(Vuex);
Vue.use(VueQuillEditor);
Vue.use(Print);

// 全局错误处理 - 处理未被axios拦截器捕获的错误
Vue.config.errorHandler = function (err, vm, info) {
    console.error('Vue Error:', err, info);

    // 检查是否是认证错误
    if (err.message && (err.message.includes('Token expired') || err.message.includes('401'))) {
        console.log('Vue errorHandler detected token expired error');
        // 清除本地存储
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('authorization');
        localStorage.removeItem('authorization');

        // 显示错误消息
        if (vm && vm.$message) {
            vm.$message.error('登录已过期，请重新登录');
        }

        // 重定向到登录页
        setTimeout(() => {
            window.location.href = window.location.origin + '/';
        }, 1000);
    }
};

// 全局混入，为所有组件添加错误处理
Vue.mixin({
    methods: {
        // 处理API调用错误的统一方法
        handleApiError(error) {
            console.log('Component handleApiError:', error);
            if (error.response && error.response.status === 401) {
                this.$message.error('登录已过期，请重新登录');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('authorization');
                localStorage.removeItem('authorization');
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
                return true; // 表示已处理
            }
            return false; // 表示未处理，应继续抛出错误
        }
    }
});


global.antRouter = '' //全局的路由

NProgress.configure({showSpinner: false});
const router = new VueRouter({
    routes
});
let addRouFlag = false;

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.path === '/login') {
        //sessionStorage.removeItem('user');
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    let token = sessionStorage.getItem('authorization');

    // 检查用户信息和token是否都存在
    if ((!user || !token) && to.path !== '/login'&&to.path !== '/forgetPassword'&&to.path !== '/changePassword' && to.path.indexOf("/register") === -1) {
        // 清除可能残留的认证信息
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('authorization');
        localStorage.removeItem('authorization');
        next({path: '/login'})
    } else {
        if (user && !addRouFlag) {
            let role = user.roleId;

            addRouFlag = true;
            // 2.根据用户的角色、和需要动态展示的路由，生成符合用户角色的路由
            let menu = getMenuByRole(role);
            // 3.利用global属性，让渲染菜单的组件sideMeuns.vue重新生成左侧菜单
            global.antRouter = menu;
            // 4.将生成好的路由addRoutes
            router.addRoutes(menu);
            // 5.push之后，会重新进入到beforeEach的钩子里,直接进入第一个if判断
            router.push({path: to.path})
        }
        next();
    }
});

const getMenuByRole = (roleId) => {
    if (roleId === "1") {
        return defaultRoutes.concat(doctorRoutes);
    } else if (roleId === "2") {
        return defaultRoutes.concat(nurseRoutes);
    } else if (roleId === "3") {
        return defaultRoutes.concat(warehouseAdminRoutes);
    }else if(roleId==='0'){
        return defaultRoutes.concat(superAdminRouter);
    }
}

router.afterEach(transition => {
    NProgress.done();
});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js